import { Form, Select } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../../store';
import mask from '../../../../../../utils/mask';
import { ParceiroProps } from './props';

const SelectRemetente: React.FC<ParceiroProps> = ({ setRemetente, name }) => {
  const parceiro = useSelector((state: ApplicationState) => state.auth.user?.inscricoesEstaduais);
  const { Option } = Select;
  const children: any = [];

  const onChangeParc = (values: any) => {
    // eslint-disable-next-line array-callback-return
    parceiro?.map((item: any) => {
      if (item.codParceiro === values) {
        setRemetente(item);
      }
    });
  };

  children.push(
    parceiro?.map((inscData, index) => (
      <Option
        title={inscData.nomeParceiro}
        className="optionselect"
        value={inscData.codParceiro}
        key={inscData.codParceiro}
      >
        CNPJ/CPF: {mask('cpfCnpj', inscData.cnpjcpf)} <br />
        Inscrição estadual: {inscData.inscricaoEstadual} <br />
        Nome: {inscData.nomeParceiro} - Código: {inscData.codParceiro}
        <hr />
      </Option>
    ))
  );

  return (
    <>
      <Form.Item name={name}>
        <Select
          showSearch
          style={{ width: '100%' }}
          filterOption={(inputValue, element) =>
            element?.props.children.toString().toLowerCase().includes(inputValue.toLowerCase())
          }
          onChange={onChangeParc}
        >
          {children}
        </Select>
      </Form.Item>
    </>
  );
};

export default SelectRemetente;
